import { List as AntdList } from "antd";
import type { ListProps } from "antd";

export function List<T>({ pagination, ...rest }: ListProps<T>) {
  return (
    <AntdList
      pagination={
        typeof pagination === "boolean" || typeof pagination === "undefined"
          ? pagination
          : {
              hideOnSinglePage: true,
              ...pagination,
            }
      }
      {...rest}
    />
  );
}

List.Item = AntdList.Item;
List.Item.Meta = AntdList.Item.Meta;
